import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { useStateContext } from "../../../contexts/ContextProvider";
import { Loader, SearchBar } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Colors } from "../../../constants/styles";
import { formatDate } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
  Paper,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { NumericFormat } from "react-number-format";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahRab = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noRab, setNoRab] = useState("");
  const [tanggalDpRab, setTanggalDpRab] = useState(new Date());
  const [namaArsitek, setNamaArsitek] = useState("");
  const [kodeArsitek, setKodeArsitek] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [kodeProyek, setKodeProyek] = useState("");
  const [linkDokumenRab, setLinkDokumenRab] = useState("");
  const [keteranganRab, setKeteranganRab] = useState("");

  const [arsiteks, setArsiteks] = useState([]);
  const [proyeks, setProyeks] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchTermArsitek, setSearchTermArsitek] = useState("");
  const [openArsitek, setOpenArsitek] = useState(false);
  const [searchTermProyek, setSearchTermProyek] = useState("");
  const [openProyek, setOpenProyek] = useState(false);

  // Data Child
  const [totalTransaksi, setTotalTransaksi] = useState(0);
  const [reloadListRabPekerjaan, setReloadListRabPekerjaan] = useState(0);
  const [listRabPekerjaan, setListRabPekerjaan] = useState([
    {
      namaRabPekerjaan: "",
      namaRabPekerjaanChild: "",
      jumlah: 0,
      satuan: "",
      keteranganRabPekerjaan: "",
    },
  ]);

  let satuanOptions = [
    {
      label: "M2",
    },
    {
      label: "M",
    },
    {
      label: "UNIT",
    },
    {
      label: "SET",
    },
  ];

  let [pageArsitek, setPageArsitek] = useState(0);
  const [limitArsitek, setLimitArsitek] = useState(10);
  const [pagesArsitek, setPagesArsitek] = useState(0);
  const [rowsArsitek, setRowsArsitek] = useState(0);
  const [queryArsitek, setQueryArsitek] = useState("");

  const handleChangeArsitek = (e, p) => {
    setPageArsitek(p - 1);
  };

  let [pageProyek, setPageProyek] = useState(0);
  const [limitProyek, setLimitProyek] = useState(10);
  const [pagesProyek, setPagesProyek] = useState(0);
  const [rowsProyek, setRowsProyek] = useState(0);
  const [queryProyek, setQueryProyek] = useState("");

  const handleChangeProyek = (e, p) => {
    setPageProyek(p - 1);
  };

  const classes = useStyles();

  const searchDataArsitek = (e) => {
    e.preventDefault();
    setPageArsitek(0);
    setSearchTermArsitek(queryArsitek);
  };

  const handleClickOpenArsitek = () => {
    setOpenArsitek(true);
  };

  const handleCloseArsitek = () => {
    setOpenArsitek(false);
  };

  const searchDataProyek = (e) => {
    e.preventDefault();
    setPageProyek(0);
    setSearchTermProyek(queryProyek);
  };

  const handleClickOpenProyek = () => {
    setOpenProyek(true);
  };

  const handleCloseProyek = () => {
    setOpenProyek(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getArsiteksData();
  }, [pageArsitek, searchTermArsitek]);

  useEffect(() => {
    getProyeksData();
  }, [pageProyek, searchTermProyek]);

  const getArsiteksData = async () => {
    const response = await postRequest(
      `/arsiteksPagination?search_query=${searchTermArsitek}&page=${pageArsitek}&limit=${limitArsitek}`,
      {},
      navigate,
      dispatch
    );
    setArsiteks(response.data.arsiteks);
    setPageArsitek(response.data.page);
    setPagesArsitek(response.data.totalPage);
    setRowsArsitek(response.data.totalRows);
  };

  const getProyeksData = async () => {
    const response = await postRequest(
      `/proyeksPagination?search_query=${searchTermProyek}&page=${pageProyek}&limit=${limitProyek}`,
      {},
      navigate,
      dispatch
    );
    setProyeks(response.data.proyeks);
    setPageProyek(response.data.page);
    setPagesProyek(response.data.totalPage);
    setRowsProyek(response.data.totalRows);
  };

  const saveRab = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      tanggalDpRab !== null &&
      kodeProyek.length !== 0
    ) {
      setLoading(true);
      await postRequest(
        `/saveRabAndSaveTransaksi`,
        {
          noRab,
          tanggalDpRab,
          kodeArsitek,
          kodeProyek,
          linkDokumenRab,
          keteranganRab,

          listRabPekerjaan,
        },
        navigate,
        dispatch
      );
      setLoading(false);
      navigate("/daftarRab");
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Proyek</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah RAB</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveRab}>
        <Card>
          <Card.Header>RAB</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    No. RAB <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      required
                      value={noRab}
                      onChange={(e) => setNoRab(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Tgl. Dp Rab <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="9">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={tanggalDpRab}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setTanggalDpRab(date);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Arsitek :
                  </Form.Label>
                  <Col sm="5">
                    <Form.Control value={namaArsitek} disabled readOnly />
                  </Col>
                  <Col sm="4">
                    <Form.Control value={kodeArsitek} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Proyek <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="5">
                    <Form.Control value={namaCustomer} disabled readOnly />
                  </Col>
                  <Col sm="4">
                    <Form.Control
                      required
                      value={kodeProyek}
                      readOnly
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenProyek()}
                      isInvalid={kodeProyek.length === 0 && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Link Dokumen :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={linkDokumenRab}
                      onChange={(e) => setLinkDokumenRab(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keteranganRab}
                      onChange={(e) => setKeteranganRab(e.target.value)}
                      style={{ textTransform: "uppercase" }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                color="info"
                sx={{
                  bgcolor: "info.light",
                  textTransform: "none",
                  marginRight: 2,
                  marginBottom: 2,
                }}
                onClick={() => {
                  listRabPekerjaan.push({
                    namaRabPekerjaan: "",
                    namaRabPekerjaanChild: "",
                    jumlah: 0,
                    satuan: "",
                    keteranganRabPekerjaan: "",
                  });
                  setReloadListRabPekerjaan(Math.floor(Math.random() * 1000));
                }}
              >
                {"+ Input Transaksi"}
              </Button>
            </Box>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                      className={classes.tableRightBorder}
                      colSpan={4}
                    >
                      Pekerjaan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Hapus
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listRabPekerjaan.map((rabPekerjaan, index) => (
                    <TableRow>
                      <TableCell>
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={4}
                          value={rabPekerjaan.namaRabPekerjaan}
                          onChange={(e) => {
                            rabPekerjaan.namaRabPekerjaan = e.target.value;
                            setReloadListRabPekerjaan(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={4}
                          value={rabPekerjaan.namaRabPekerjaanChild}
                          onChange={(e) => {
                            rabPekerjaan.namaRabPekerjaanChild = e.target.value;
                            setReloadListRabPekerjaan(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <div style={{ display: "flex", maxWidth: "300px" }}>
                          <div style={{ flex: 1 }}>
                            <Form.Control
                              type="number"
                              value={rabPekerjaan.jumlah}
                              onChange={(e) => {
                                rabPekerjaan.jumlah = e.target.value;
                                setReloadListRabPekerjaan(
                                  Math.floor(Math.random() * 1000)
                                );
                              }}
                            />
                          </div>

                          <div style={{ flex: 2, marginLeft: "6px" }}>
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={satuanOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              value={rabPekerjaan.satuan}
                              onChange={(e, value) => {
                                rabPekerjaan.satuan = value.label;
                                setReloadListRabPekerjaan(
                                  Math.floor(Math.random() * 1000)
                                );
                              }}
                            />
                          </div>
                        </div>
                      </TableCell>
                      <TableCell align="right">
                        <Form.Control
                          style={{ textTransform: "uppercase" }}
                          as="textarea"
                          rows={4}
                          value={rabPekerjaan.keteranganRabPekerjaan}
                          onChange={(e) => {
                            rabPekerjaan.keteranganRabPekerjaan =
                              e.target.value;
                            setReloadListRabPekerjaan(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="error"
                          sx={{ textTransform: "none" }}
                          onClick={() => {
                            listRabPekerjaan.splice(index, 1);
                            setReloadListRabPekerjaan(
                              Math.floor(Math.random() * 1000)
                            );
                          }}
                        >
                          <DeleteOutlineIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarRab")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openArsitek}
        onClose={handleCloseArsitek}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Arsitek`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataArsitek}>
              <Box sx={searchBarContainer}>
                <SearchBar
                  value={queryArsitek}
                  setSearchTerm={setQueryArsitek}
                />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>No. Telp</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {arsiteks.map((arsitek, index) => (
                    <TableRow
                      key={arsitek._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setKodeArsitek(arsitek.kodeArsitek);
                        setNamaArsitek(arsitek.namaArsitek);

                        handleCloseArsitek();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {arsitek.kodeArsitek}
                      </TableCell>
                      <TableCell>{arsitek.namaArsitek}</TableCell>
                      <TableCell>{arsitek.teleponArsitek}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesArsitek}
                page={pageArsitek + 1}
                onChange={handleChangeArsitek}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openProyek}
        onClose={handleCloseProyek}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Proyek`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataProyek}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryProyek} setSearchTerm={setQueryProyek} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Tgl.
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama Customer
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {proyeks.map((proyek, index) => (
                    <TableRow
                      key={proyek._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setKodeProyek(proyek.kodeProyek);
                        setNamaCustomer(proyek.customer.namaCustomer);
                        setKodeArsitek(proyek.arsitek.kodeArsitek);
                        setNamaArsitek(proyek.arsitek.namaArsitek);

                        handleCloseProyek();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {proyek.kodeProyek}
                      </TableCell>
                      <TableCell>{formatDate(proyek.tanggalProyek)}</TableCell>
                      <TableCell>{proyek.customer.namaCustomer}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesProyek}
                page={pageProyek + 1}
                onChange={handleChangeProyek}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahRab;

const colorRed = {
  color: "red",
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
